<template>
  <div id="software">
     <div class="text">
        <p>一、项目概况</p>
        <p>
         基于全员人口信息大数据，以居民属性及居民关系两个核心维度为顶层设计，向下细分进行归纳存储，通过数据共享能力打通民政、公安、人社、工商、教育部门等数据，将居民从出生至死亡的所有数据进行聚合、分类，分析出户籍关系数据、核心家庭关系数据、生育关系数据、婚姻关系数据，为解决“办证难”引发的社会矛盾提供可靠的数据依据，对人口与健康行业的深化管理与监测发展提供数据支持。主要系统包括：全员人口个人信息管理系统、便民服务管理信息系统、流动人口服务管理平台、计划生育统计监测信息系统、流动人口电子婚育证明管理、办理场景式服务大厅等。
        </p>
       <p>二、建设的必要性</p>
       <p>1、加强和创新社会管理的基础工程</p>
       <p>社会管理，说到底是对人的管理。我国正处于经济转轨、社会转型的历史时期，随着工业化、城镇化、市场化、信息化、国际化的深入发展，受体制机制、信息分割和资源配置的制约，原有的社会管理体制机制和手段方法已经不能完全适应经济社会发展的客观要求，必须适应新形势、新任务的要求，深入推进社会管理创新。
        完善社会管理体系，难点在全面掌握人口动态信息。随着经济增长和结构调整，人口流动日益活跃，人的社会经济活动日趋多样化，人口信息掌握难，社会管理难以实现有效覆盖、资源共享和均等化服务。按照中央关于统筹城乡发展、统筹区域发展、统筹经济社会发展、统筹人与自然和谐的要求，加快建设“金人工程”，为不断完善社会管理和服务政策，切实解决好广大人民群众生活、就业、就医、教育、住房、社保等实际问题，推动建立统筹管理、服务均等、信息共享、区域协作的公共管理与服务机制，为政府合理配置公共管理资源、加强部门协调、化解社会矛盾提供支撑。
        完善社会管理体系，重点在依靠人民群众。传统体制下的社会管理依靠政府的权威实行社会控制，现代社会管理是一种规范的公共治理结构下的公民参与以及公民与政府之间的良性互动机制。要适应现代社会管理公共治理的基本趋势，在充分发挥基层政府作用的基础上，调动全社会的参与积极性，进一步夯实群众工作基础，提高社会自治与自我服务能力。要充分利用人口计生部门延伸到基层的网络优势，借助“金人工程”，建立群众和政府职能部门的互动渠道，根据群众需求，完善社会管理和公共服务内容、方式和方法，切实解决人民群众关心的问题。开展健康信息咨询服务试点，推动提高人口健康素质。以全员人口信息为基础，以完善人口管理体系为着力点，优化公共资源配置，构建社会管理和公共服务平台。
      </p>
      <p>2、是转变社会经济发展方式的迫切要求</p>
      <p>人口问题在经济社会发展中始终处于基础性地位，与经济结构调整密切相关，是影响经济长远发展的重要因素。尽管我国曾长期面临人口多、底子薄的情况，但随着人口发展进入新阶段，目前我国已进入人口负增长时期，2022 - 2024 年人口连续三年减少。不过，人口问题依然是我国社会主义初级阶段需重点关注的国情之一。
        当前，虽然人口总量的减少使人口资源紧张关系得到一定程度缓解，但随着经济总量的持续扩大，人均资源相对不足的问题仍然存在，且由于人口老龄化加速、区域人口增减分化加剧等因素，经济社会发展不平衡的矛盾愈发突出。人口年龄结构快速向重度老龄化迈进，预计 2035 年左右，60 岁及以上老年人口将突破 4 亿人，占总人口的比例将超过 30%。同时，区域间人口分布变化加速，人口（人才）竞争加剧，给基础设施建设和公共资源配置带来新挑战，人口资源环境约束依然较强，仍是制约现代化建设的瓶颈和影响国家安全的因素。
        面对这些情况，“既要进行动态监测，又要做好科学预测”，“搞好人口与发展综合决策” 尤为重要。围绕当前人口与资源环境以及经济社会发展面临的突出矛盾，为促进经济结构调整更好地适应人口结构的变化，需加快建设人口决策支持系统。具体而言，要开展分地区人口发展趋势预测，科学研判中长期人口数量、结构发展变化趋势，为编制经济社会发展规划，制定教育、健康、就业等相关公共政策提供依据，以应对人口负增长、老龄化等带来的劳动力减少、公共服务需求结构变化等问题。</p>
        <p>二、业务逻辑</p>
      <p>按照人口业务职能将业务架构划分为四部分，分别是：1.	常住人口管理；2.	流动人口管理；3.	出生人口管理；4.	死亡人口管理</p>
      <p>针对全员人口对象的全生命周期管理，均有相应的静态管理、动态管理和应急保障等流程框架设计。业务流程设计遵循端到端的原则，即由对象发起业务，经各业务单元或部门协同，最终将业务落实到服务能力与资源提供上，将人口业务职能映射到各个业务对象的相应流程环节中，形成“人口平台”的业务流程框架。在业务架构的基础上，采用“自顶向下、逐步分解”的方法，细化各业务单元，形成人口系统总体业务架构。</p>
      <div class="flex">
        <img
          src="@/assets/images/pic200-26.png"
          style="width: 100%;"
          alt=""
        />
      </div>
     
        <p>三、建设内容</p>
        <p>根据顶层设计的相关要求，对于每个业务对象域均有相应的静态管理、动态管理和应急保障等流程环节，从而形成每个业务对象域的全生命周期管理。将人口业务职能映射到各个业务对象的相应流程环节中，形成“人口平台”的标准规范的业务结构。</p>
        <p>基于“人口平台”标准规范的业务结构，可以对“人口平台”的信息化建设中相关对象进行抽象，总结出“人口平台”总体所需要包括的功能域和子功能，形成其的总体功能结构</p>
        <div class="flex">
          <img
            src="@/assets/images/pic200-7.png"
            style="width: 100%;"
            alt=""
          />
        </div>
      <p>在此基础上，采用“自顶向下，逐步分解”的方法，细化出功能架构设计图及功能说明。
        依据“人口平台”标准规范顶层设计方法，划分目标是依据业务架构和人口数据信息化现状，基于业务横向整合的原则进行标准规范原型的的划分。标准规范原型最终的目标划分总体标准、数据标准、应用标准三大目标。标准规范原型设计建设的核心目标体现为对建设“两级信息处理（国家和省级）、三大数据库（人口与计生业务数据库、全员人口个人数据库、全员人口决策支持数据库）、三大业务应用系统（人口与计生服务管理、人口变动信息校核与引导服务、人口决策支持）”的标准化体系支撑。
      </p>
       </div>
  </div>
</template>
<script>
export default {
  name: "software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
  line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
   text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution8.vue